import { el, clear, qs } from "../../utils/dom";
import { getState, setState } from "../../state/store";
import { nid } from "../../utils/id";

export function mountClassSwitcher() {
    const host = qs("#class-switcher");
    render();

    function render() {
        // Save focus state before re-render
        const activeEl = document.activeElement as HTMLInputElement | null;
        const focusedClassId = activeEl?.dataset.classId;
        const cursorPos = activeEl?.selectionStart ?? null;

        clear(host);
        const s = getState();
        const list = el("div", { class: "list" });

        for (const c of s.classes) {
            const input = el("input", {
                type: "text",
                value: c.name,
                "data-class-id": c.id,
                oninput: (e: any) => {
                    setState(ns => { const cc = ns.classes.find(x => x.id === c.id)!; cc.name = e.target.value; });
                }
            }) as HTMLInputElement;

            const row = el("div", { class: "row" },
                input,
                el("button", { onclick: () => setState(ns => { ns.activeClassId = c.id; }) }, s.activeClassId === c.id ? "Active" : "Make Active"),
            );
            list.appendChild(row);

            // Restore focus if this was the focused input
            if (focusedClassId === c.id) {
                requestAnimationFrame(() => {
                    input.focus();
                    if (cursorPos !== null) {
                        input.setSelectionRange(cursorPos, cursorPos);
                    }
                });
            }
        }

        const add = el("button", { class: "primary" }, "New Class");
        add.addEventListener("click", () => {
            const id = nid("cls_");
            setState(ns => {
                ns.classes.push({
                    id, name: `Class ${ns.classes.length + 1}`,
                    students: [], constraints: { mustTogether: [], mustApart: [] },
                    settings: {
                        targetSize: 4, minSize: 3, maxSize: 5,
                        balanceSkill: true, tagBehavior: new Map(),
                        tags: [], mode: 'groups'
                    },
                    lastGroups: []
                });
                ns.activeClassId = id;
            });
        });

        const rename = el("div", {}, el("span", { class: "badge" }, "Quick switcher ready"));
        host.append(el("h3", {}, "Classes"), list, add, rename);
    }

    document.addEventListener("state:update", render);
}
